import { Stack, Typography } from "@mui/material";

const ChipInfo = ({ size, label, Icon, sx }) => (
  <Stack direction="row" alignItems="center" spacing={1} sx={sx}>
    {Icon ? (
      <Icon
        sx={{
          height: size === "small" ? 12 : 16,
          width: size === "small" ? 12 : 16,
          color: "var(--surface-on-variant)"
        }}
      />
    ) : undefined}
    <Typography
      color="var(--surface-on-color)"
      variant={
        size === "small" ? "labelSm" : size === "medium" ? "labelMd" : "labelLg"
      }
    >
      {label}
    </Typography>
  </Stack>
);

export default ChipInfo;
